import { Persistor, persistReducer, persistStore } from 'redux-persist'
import { Reducers } from './ducks'
import storage from 'redux-persist/lib/storage'
import { configureStore } from '@reduxjs/toolkit'

const key = `OAC_CHECKOUT_${process.env.NODE_ENV}`
const persistConfig = {
	key: key,
	storage,
	whitelist: ['user', 'token']
}

const persistedReducer = persistReducer(persistConfig, Reducers)

export const store = configureStore({
	reducer: persistedReducer,
	middleware: []
})

export const persistor: Persistor = persistStore(store)
